function initSubscriptionWidget() {
    // Event delegation for radio button changes
    document.body.addEventListener('change', function(event) {
        if (event.target.matches('input[name="nw-plan-picker"]')) {
            const selectedValue = event.target.value;
            
            if (selectedValue === 'subscription') {
                //console.log('Subscription selected');
                // Add your custom code for subscription selection here
                
                // Example: Show/hide price elements
                document.querySelectorAll('[data-subscription-element]').forEach(el => {
                    el.classList.remove('hidden');
                });
                document.querySelectorAll('[data-onetime-element]').forEach(el => {
                    el.classList.add('hidden');
                });
            } else if (selectedValue === 'one-time') {
                //console.log('One-time purchase selected');
                // Add your custom code for one-time purchase selection here
                
                // Example: Show/hide price elements
                document.querySelectorAll('[data-subscription-element]').forEach(el => {
                    el.classList.add('hidden');
                });
                document.querySelectorAll('[data-onetime-element]').forEach(el => {
                    el.classList.remove('hidden');
                });
            }
        }
    });
}

// Add to cart function
async function handleAddToCart(button) {
    // Add loading state
    button.classList.add('loading');
    
    try {
        // Get the selected variant ID
        const variantId = document.querySelector('variant-selects[data-selected-id]')?.getAttribute('data-selected-id');
        if (!variantId) {
            throw new Error('No variant selected');
        }

        // Get the selected purchase type (subscription or one-time)
        const selectedPurchaseType = document.querySelector('input[name="nw-plan-picker"]:checked')?.value;
        
        // Prepare cart data
        const cartData = {
            items: [{
                id: variantId,
                quantity: 1
            }]
        };

        // If subscription is selected, add selling plan
        if (selectedPurchaseType === 'subscription') {
            const sellingPlanSelect = document.querySelector('select[name="selling_plan"]');
            if (sellingPlanSelect) {
                const sellingPlanId = sellingPlanSelect.value;
                cartData.items[0].selling_plan = sellingPlanId;
            }
        }

        // Add to cart API call
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(cartData)
        });

        if (!response.ok) {
            throw new Error('Failed to add to cart');
        }

        const result = await response.json();
        //console.log('Added to cart:', result);

        // Refresh cart and open drawer
        fetch('/cart?view=ajax')
            .then(function (response) {
                return response.text();
            })
            .then(function (html) {
                var parser = new DOMParser();
                var cartHTML = parser.parseFromString(html, 'text/html');
                var cart_ajax = document.querySelector('#cart-main-ajax');
                cart_ajax.innerHTML = cartHTML.querySelector('body').innerHTML;
                
                // Run any additional cart functions if they exist
                if (typeof bindQuantityFields === 'function') {
                    bindQuantityFields();
                }
                if (typeof reloadShoppingGivesWidget === 'function') {
                    setTimeout(reloadShoppingGivesWidget, 100);
                }
                if (typeof clearCartAttributesIfEmpty === 'function') {
                    clearCartAttributesIfEmpty();
                }
            })
            .catch(error => console.warn('Something went wrong refreshing cart.', error))
            .finally(() => {
                if (typeof toggleCartLoader === 'function') {
                    toggleCartLoader(false);
                }
            });

        // Open cart drawer
        const ajaxCart = document.querySelector('.ajax-cart');
        if (ajaxCart && !ajaxCart.classList.contains('open')) {
            ajaxCart.classList.add('open');
        }

    } catch (error) {
        console.error('Error adding to cart:', error);
        // Optional: Show error message to user
    } finally {
        // Remove loading state
        button.classList.remove('loading');
    }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', initSubscriptionWidget);

// Watch for dynamic content changes
const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
            // Check if our widget is added
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1 && (
                    node.matches('#nw-subscription-widget') || 
                    node.querySelector('#nw-subscription-widget')
                )) {
                    initSubscriptionWidget();
                }
            });
        }
    });
});

// Start observing the body for dynamic changes
observer.observe(document.body, {
    childList: true,
    subtree: true
});
